import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import it from "./it.json";

export default { en, fr, de, it }
